import { render, staticRenderFns } from "./DealOrder.vue?vue&type=template&id=b201f2e6"
import script from "./DealOrder.vue?vue&type=script&lang=js"
export * from "./DealOrder.vue?vue&type=script&lang=js"
import style0 from "./DealOrder.vue?vue&type=style&index=0&id=b201f2e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports